module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/person icon-9259fb5f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/person icon.svg
// module id = ./app/web/src/assets/person icon.svg
// module chunks = 0